import { css } from "styled-components";

export const createCssProperty = (property: string, value?: string | number) =>
    value
        ? css`
              ${property}: ${value};
          `
        : "";
